import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MainHeader from "../../Components/Header/MainHeader";
import MainFooter from "../../Components/Footer/MainFooter";
import { db, functionsInstance } from "../../Database/RekebishaAdmin/config";

// Reached only from OUTSIDE the FundiUpdated app (a link shared via WhatsApp/SMS,
// or typed into a browser) — FundiUpdated itself never links here. This keeps the
// paid-subscription flow off Google Play's billing requirement: the purchase is
// never initiated from, or linked to from within, the Android/iOS app.
const TIERS = [
  { id: "diamond", label: "Diamond", priceKES: 500, benefit: "Included in the Rekebisha ad pool for your trade." },
  { id: "gold", label: "Gold", priceKES: 1000, benefit: "Higher weight in the ad pool — shown more often." },
  { id: "enterprise", label: "Enterprise", priceKES: 2500, benefit: "Highest weight in the ad pool and top ranking in-app." },
];

export default function Subscribe() {
  const { fundiId } = useParams();
  const [fundiName, setFundiName] = useState("");
  const [loadingFundi, setLoadingFundi] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [selectedTier, setSelectedTier] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const doc = await db.collection("FundiAppUsers").doc(fundiId).get();
        if (!doc.exists) {
          setNotFound(true);
        } else {
          const data = doc.data();
          setFundiName([data.firstname, data.lastname].filter(Boolean).join(" "));
        }
      } catch (e) {
        setNotFound(true);
      } finally {
        setLoadingFundi(false);
      }
    };
    load();
  }, [fundiId]);

  const handleSubscribe = useCallback(async () => {
    if (!selectedTier) return;
    setSubmitting(true);
    setError(null);
    try {
      const initiateSubscriptionPayment = functionsInstance.httpsCallable("initiateSubscriptionPayment");
      const result = await initiateSubscriptionPayment({ fundiId, tier: selectedTier });
      window.location.href = result.data.redirectUrl;
    } catch (e) {
      setError(e.message || "Something went wrong starting your payment. Please try again.");
      setSubmitting(false);
    }
  }, [fundiId, selectedTier]);

  return (
    <>
      <MainHeader />
      <main className="max-w-2xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold text-navy mb-1">Rekebisha Subscription</h1>

        {loadingFundi && <p className="text-gray-500 mt-4">Loading…</p>}

        {!loadingFundi && notFound && (
          <p className="text-red-600 mt-4">
            We couldn't find this fundi account. Check the link and try again, or contact support.
          </p>
        )}

        {!loadingFundi && !notFound && (
          <>
            <p className="text-gray-600 mb-6">
              {fundiName ? `Subscribing as ${fundiName}.` : null} Choose a plan to get listed in
              Rekebisha's Facebook &amp; Instagram ads.
            </p>

            <div className="grid gap-4 mb-6">
              {TIERS.map((tier) => (
                <button
                  key={tier.id}
                  type="button"
                  onClick={() => setSelectedTier(tier.id)}
                  className={`text-left rounded-xl border p-4 transition-colors ${
                    selectedTier === tier.id
                      ? "border-brandgreen bg-green-50"
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <div className="flex items-baseline justify-between">
                    <span className="font-semibold text-navy">{tier.label}</span>
                    <span className="text-navy font-bold">KES {tier.priceKES.toLocaleString()}/mo</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">{tier.benefit}</p>
                </button>
              ))}
            </div>

            {error && <p className="text-sm text-red-600 mb-4">{error}</p>}

            <button
              type="button"
              onClick={handleSubscribe}
              disabled={!selectedTier || submitting}
              className="w-full bg-brandgreen text-white py-3 px-4 rounded-lg font-medium hover:bg-brandgreen-dark transition-colors disabled:opacity-50"
            >
              {submitting ? "Redirecting to payment…" : "Continue to payment"}
            </button>
          </>
        )}
      </main>
      <MainFooter />
    </>
  );
}
